import React from "react";
import { cn } from "../../lib/utils";
import { Button } from "../ui/button";

interface BrandedButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "outline";
  size?: "sm" | "md" | "lg";
  fullWidth?: boolean;
  children: React.ReactNode;
}

const variantMap: Record<NonNullable<BrandedButtonProps["variant"]>, string> = {
  // map to the "custom" variant so we can fully control styling via classes
  primary: "custom",
  secondary: "secondary",
  outline: "custom",
};

const sizeMap: Record<NonNullable<BrandedButtonProps["size"]>, string> = {
  sm: "sm",
  md: "default",
  lg: "lg",
};

const BrandedButton: React.FC<BrandedButtonProps> = ({
  variant = "primary",
  size = "md",
  fullWidth = false,
  className,
  children,
  ...props
}) => {
  const mappedVariant = variantMap[variant] || "default";
  const mappedSize = sizeMap[size] || "default";

  const variantClasses =
    variant === "primary"
      ? "bg-orange-500 hover:bg-orange-600 text-white"
      : variant === "outline"
      ? "border border-orange-500 text-orange-500 hover:bg-orange-50"
      : "";

  return (
    <Button
      variant={mappedVariant as any}
      size={mappedSize as any}
      className={cn(variantClasses, fullWidth && "w-full", className)}
      {...(props as any)}
    >
      {children}
    </Button>
  );
};

export default BrandedButton;
